import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronLeft = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M14 6L8 12L14 18'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.4697 5.46973C13.7626 5.17684 14.2374 5.17684 14.5303 5.46973C14.8232 5.76262 14.8232 6.23738 14.5303 6.53028L9.06055 12L14.5303 17.4697L14.582 17.5264C14.8223 17.821 14.8049 18.2557 14.5303 18.5303C14.2557 18.8049 13.8209 18.8223 13.5264 18.582L13.4697 18.5303L7.46973 12.5303C7.32908 12.3896 7.25 12.1989 7.25 12C7.25 11.8011 7.32908 11.6104 7.46973 11.4697L13.4697 5.46973Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
